var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{attrs:{"placeholder":_vm.value||'请选择所在地区',"size":"small","options":_vm.options,"clearable":""},on:{"change":_vm.handleChange},model:{value:(_vm.selectedOptions),callback:function ($$v) {_vm.selectedOptions=$$v},expression:"selectedOptions"}})
}
var staticRenderFns = []

export { render, staticRenderFns }